import Markdown from 'core/markdown';
import { getWidgetSettings } from 'modules/dashboard/utils/dashboardWidgetUtils';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

// css file conversion
export const StyledMarkdown = styled(Markdown)`
  &&& {
    height: calc(100% - ${pxToRem(40)});
    margin-top: ${pxToRem(40)};
    padding: 0 ${pxToRem(20)} ${pxToRem(10)};
    overflow-y: auto;
  }
`;

// type Props = {
//   widget: Record<string, any>,
// };

const MarkdownWidget = ({
  widget = {
    settings: {
      text: '',
    },
  },
}) => {
  const { text } = getWidgetSettings(widget);

  return <StyledMarkdown source={text} />;
};

export default MarkdownWidget;
